// Converts label to URL-safe slug: "Microsoft 365 & Tools" → "microsoft_365_tools"
export const generateKey = (name) =>
  name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');

// Extracts initials from label: "Collaboration & Productivity" → "CP"
export const getAvatarInitials = (label) =>
  label
    .split(/[\s&]+/)
    .filter((word) => /[A-Za-z]/.test(word?.[0] ?? ''))
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');

// Deep clones a value to avoid mutations
export const deepCloneState = (value) => JSON.parse(JSON.stringify(value));
